import { Stack, Text } from '@mantine/core';
import { Dropzone, FileWithPath } from '@mantine/dropzone';
import { IconUpload, IconPhoto, IconX } from '@tabler/icons-react';
import { ProcessedBetSlipData } from '../../../backend/src/models/BetSlip';
import { processImage } from '../services/api';
import { notifications } from '@mantine/notifications';

interface BetSlipFileUploadProps {
  onUploadStart: () => void;
  onUploadEnd: () => void;
  onUploadSuccess: (data: ProcessedBetSlipData) => void;
}

export function BetSlipFileUpload({ 
  onUploadStart, 
  onUploadEnd, 
  onUploadSuccess 
}: BetSlipFileUploadProps) {
  const handleDrop = async (files: FileWithPath[]) => {
    const file = files[0];
    if (!file) return;

    try {
      onUploadStart();
      const processedData = await processImage(file);
      console.log('File upload processed data:', {
        ...processedData,
        hasSelections: !!processedData.selections,
        selectionsLength: processedData.selections?.length,
        method: 'upload'
      });
      onUploadSuccess(processedData);
    } catch (error) {
      console.error('Upload error:', error);
      notifications.show({
        title: 'Error',
        message: 'Failed to process bet slip image',
        color: 'red'
      });
    } finally {
      onUploadEnd();
    }
  };

  return (
    <Dropzone
      onDrop={handleDrop}
      maxSize={10 * 1024 * 1024} // 10MB
      accept={['image/jpeg', 'image/png', 'image/webp']}
      multiple={false}
    >
      <Stack align="center" sx={{ minHeight: 220, pointerEvents: 'none', gap: '1rem' }}>
        <Dropzone.Accept>
          <IconUpload size={50} stroke={1.5} />
        </Dropzone.Accept>
        <Dropzone.Reject>
          <IconX size={50} stroke={1.5} />
        </Dropzone.Reject>
        <Dropzone.Idle>
          <IconPhoto size={50} stroke={1.5} />
        </Dropzone.Idle>

        <div>
          <Text size="xl" sx={{ display: 'inline' }}>
            Drag bet slip here or click to select
          </Text>
          <Text size="sm" color="dimmed" sx={{ display: 'inline', marginTop: '7px' }}>
            Upload a clear photo of your bet slip (JPEG, PNG, or WebP, max 10MB)
          </Text>
        </div>
      </Stack>
    </Dropzone>
  );
}